import classNames from 'classnames';
import { ReactElement } from 'react';
import Dialog from './dialog.tsx';

const Drawer = ({ children, dialogClass, height = '80%', ...props }: {
  children: ReactElement;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  dialogClass?: string;
  onClose?: (() => void);
  height?: string;
}) => (
  <Dialog {...props}
    overlayClass="backdrop-blur-[7.5px] items-end md:items-center"
    dialogClass={classNames(
      'bg-purple-90 h-[90dvh] rounded-t-[32px]',
      'lg:h-[66dvh] lg:w-[28vw] md:h-[56dvh] md:w-[60vw] md:rounded-[32px] lg:rounded-[32px]',
      dialogClass,
    )}
    isDrawer
    height={height}
  >
    {children}
  </Dialog>
);

export default Drawer;
